import { isMobile, isMobileOnly } from 'react-device-detect'

const isIPadOs =
  window.AuthenticatorAssertionResponse === undefined &&
  window.AuthenticatorAttestationResponse === undefined &&
  window.AuthenticatorResponse === undefined &&
  window.Credential === undefined &&
  window.DeviceMotionEvent !== undefined &&
  window.DeviceOrientationEvent !== undefined &&
  navigator.maxTouchPoints === 5 &&
  navigator.plugins.length === 0 &&
  navigator.platform !== 'iPhone'

const isMobileDevice = isMobile || isIPadOs

export { isMobileDevice, isMobileOnly }
